export const inview = {
  threshold: 0.1,
  triggerOnce: true
}

export const transformArticleRelevanceForDataLayerObject = (
  articleRelevance?: { kind: 'Featured'; position: 1 | 2} | 'SemiFeatured'
) : 'list_article' | 'row_article' | 'top1_article' | 'top2_article' => {
  if (articleRelevance === undefined) return 'list_article'
  if (articleRelevance === 'SemiFeatured') return 'row_article'
  return `top${articleRelevance.position}_article`
}
